(function () {
  'use strict';

  const shop = 'https://xdnvi8-dp.myshopify.com';
  const productHandle = 'interlocking-composite-deck-tiles-300-x-300-mm';
  const finishes = [
    { id: 'deck-black', name: 'Black', fr: 'Noir', color: '#33312d', variant: '47503615393948', photo: 'main_image_showcase_tile_Topaz_Gigapixel_2x_scale.png?v=1788198860' },
    { id: 'deck-white-cream', name: 'White Cream', fr: 'Blanc crème', color: '#e7dfce', variant: '47503615492252', photo: 'main_white_cream_tile_image.png?v=1788450478' },
    { id: 'deck-tan', name: 'Tan', fr: 'Beige', color: '#b4a081', variant: '47503615459484', photo: 'tan_ceramic_tile_showcase_b0e43d8d-735c-4701-9ce3-0485368c1eb9.png?v=1789393985' },
    { id: 'deck-brown', name: 'Brown', fr: 'Brun', color: '#614d44', variant: '47503615426716', photo: 'Brown_main_image_showcase_tile_Topaz_Gigapixel_2x_scale.png?v=1789064029' }
  ];
  const copy = {
    en: {
      eyebrow: 'Cavador / Tile studio', title: 'See it in your space.',
      intro: 'Explore our interlocking deck tiles on your patio, balcony or terrace. A new perspective, before you commit.',
      stepPhoto: 'Your space', stepFinish: 'Your finish', stepPreview: 'Your preview', changePhoto: 'Change photo',
      dropTitle: 'A space. Reimagined.', dropText: 'Upload your space. Choose a finish. Let AI reimagine your floor.',
      upload: 'Upload your photo', sample: 'Try a sample space', fileHint: 'JPG, PNG or WEBP · Up to 20 MB',
      originalAlt: 'Your space before applying Cavador interlocking deck tiles', previewAlt: 'AI-generated Cavador deck tile preview',
      before: 'BEFORE', after: 'AFTER', creating: 'Creating your preview', processing: 'This may take a few minutes. Keep this page open.',
      startHint: 'Start with a clear, well-lit photo showing a generous area of visible floor.',
      comparison: 'Before and after comparison', save: 'Save preview ↓', selection: 'Deck tile finish selection',
      collection: 'The material collection', chooseFinish: 'Choose your finish.', subtitle: 'Interlocking composite deck tiles',
      choose: name => 'Choose ' + name, closeup: name => name + ' deck tile product photo',
      detail: '300 × 300 mm · Interlocking composite deck tile', generate: 'Generate my preview',
      privacy: 'When you generate a preview, your photo is processed by OpenAI.', checking: 'Checking preview availability…',
      explore: name => 'Explore ' + name + ' tiles ↗',
      lowerPhotoTitle: '01 / Your space', lowerPhoto: 'Add a clear photo of your patio, balcony or terrace. AI identifies the visible floor and creates the transformation automatically.',
      lowerFinishTitle: '02 / Your material', lowerFinish: 'Choose one of four Cavador finishes. Your preview uses the selected tile as its material reference.',
      lowerNextTitle: '03 / Your next step', lowerNext: 'Compare before and after, save your preview, then explore the tiles. AI colour, texture and scale can vary from the actual product.',
      invalidType: 'Please choose a JPG, PNG or WEBP image.', tooLarge: 'That photo is larger than 20 MB. Please choose a smaller image.',
      missingImage: 'The preview service did not return an image.', imageTimeout: 'The image took too long to load. Please try again.',
      cannotOpen: 'We could not open that image. Please try another photo.', preparing: 'Preparing your photo', opening: 'A moment while we open your space.',
      tooSmall: 'Please use a photo at least 200 × 200 pixels.', tooManyPixels: 'This photo is too large to process. Resize it to under 60 megapixels.',
      sampleAlt: 'Sample space before applying Cavador interlocking deck tiles', uploadedAlt: 'Your uploaded space before applying Cavador interlocking deck tiles',
      wait: 'Please wait…', checkPreview: 'Check my preview', generateNew: 'Generate new preview',
      unavailable: 'Tile preview generation is currently unavailable. Please try again later.',
      pendingStatus: 'Your preview may still be processing. Check it before starting another.', available: 'Choose a finish, then generate an automatic AI floor preview.',
      busyHint: 'Please keep this page open while we prepare your preview.', pendingHint: 'Your request was submitted. Check the same preview again without starting a new one.',
      oldResult: (previous, selected) => 'Showing your ' + previous + ' preview. Generate a new preview to see ' + selected + '.',
      resultHint: name => 'AI preview / ' + name + ' deck tiles. Colour, texture and scale may vary from the actual product.',
      readyHint: 'Your photo is ready. Choose your finish, then generate your preview.', resultAlt: name => 'AI-generated ' + name + ' Cavador interlocking deck tile floor preview',
      originalValue: 'Original space', previewValue: 'AI preview', percentage: value => value + '% AI preview',
      unexpectedResponse: 'The preview service returned an unexpected response. Please try again later.', serviceUnavailable: 'The preview service is unavailable. Please try again later.',
      unsupportedResult: 'The preview service returned an unsupported result.', finishedWithoutImage: 'The preview finished without an image. Please contact us for help.',
      failedPreview: 'This preview could not be generated. You can choose to start a new preview.', unconfirmedStatus: 'The preview status could not be confirmed. Please check your preview again.',
      slowPreview: 'Your preview is taking longer than expected. Select Check my preview to check the same request again.', checkingPreview: 'Checking your preview',
      unconfirmedRequest: 'The preview request could not be confirmed. It will not be retried automatically.', invalidStatusAddress: 'The preview service returned an invalid status address.',
      stillProcessing: 'Your preview is still processing. Select Check my preview to check the same request again.',
      requestTimeout: 'The request could not be confirmed. It will not be retried automatically. Please wait before starting another preview.',
      generationFailed: 'The preview could not be generated. It will not be retried automatically.'
    },
    fr: {
      eyebrow: 'Cavador / Studio des dalles', title: 'Imaginez-les chez vous.',
      intro: 'Découvrez nos dalles emboîtables sur votre patio, balcon ou terrasse. Une nouvelle perspective, avant de vous décider.',
      stepPhoto: 'Votre espace', stepFinish: 'Votre finition', stepPreview: 'Votre aperçu', changePhoto: 'Changer de photo',
      dropTitle: 'Un espace. Réinventé.', dropText: 'Ajoutez une photo. Choisissez une finition. L’IA réimagine votre sol.',
      upload: 'Ajouter votre photo', sample: 'Essayer un espace modèle', fileHint: 'JPG, PNG ou WEBP · Maximum 20 Mo',
      originalAlt: 'Votre espace avant l’ajout de dalles emboîtables Cavador', previewAlt: 'Aperçu des dalles Cavador généré par IA',
      before: 'AVANT', after: 'APRÈS', creating: 'Création de votre aperçu', processing: 'Cela peut prendre quelques minutes. Gardez cette page ouverte.',
      startHint: 'Utilisez une photo nette et bien éclairée montrant une grande surface de sol visible.',
      comparison: 'Comparaison avant et après', save: 'Enregistrer l’aperçu ↓', selection: 'Choix de la finition des dalles',
      collection: 'La collection de matériaux', chooseFinish: 'Choisissez votre finition.', subtitle: 'Dalles de terrasse emboîtables en composite',
      choose: name => 'Choisir ' + name, closeup: name => 'Photo des dalles ' + name,
      detail: '300 × 300 mm · Dalle emboîtable en composite', generate: 'Créer mon aperçu',
      privacy: 'Lorsque vous créez un aperçu, votre photo est traitée par OpenAI.', checking: 'Vérification de la disponibilité…',
      explore: name => 'Découvrir les dalles ' + name + ' ↗',
      lowerPhotoTitle: '01 / Votre espace', lowerPhoto: 'Ajoutez une photo nette de votre patio, balcon ou terrasse. L’IA repère le sol visible et crée automatiquement la transformation.',
      lowerFinishTitle: '02 / Votre matériau', lowerFinish: 'Choisissez parmi quatre finitions Cavador. L’aperçu utilise la dalle choisie comme référence de matériau.',
      lowerNextTitle: '03 / La prochaine étape', lowerNext: 'Comparez l’avant et l’après, enregistrez votre aperçu, puis découvrez les dalles. La couleur, la texture et l’échelle peuvent différer du produit réel.',
      invalidType: 'Choisissez une image JPG, PNG ou WEBP.', tooLarge: 'Cette photo dépasse 20 Mo. Choisissez une image plus petite.',
      missingImage: 'Le service d’aperçu n’a pas fourni d’image.', imageTimeout: 'Le chargement de l’image a pris trop de temps. Réessayez.',
      cannotOpen: 'Impossible d’ouvrir cette image. Essayez une autre photo.', preparing: 'Préparation de votre photo', opening: 'Un instant pendant le chargement de votre espace.',
      tooSmall: 'Utilisez une photo d’au moins 200 × 200 pixels.', tooManyPixels: 'Cette photo est trop grande. Réduisez-la à moins de 60 mégapixels.',
      sampleAlt: 'Espace modèle avant l’ajout de dalles emboîtables Cavador', uploadedAlt: 'Votre photo avant l’ajout de dalles emboîtables Cavador',
      wait: 'Veuillez patienter…', checkPreview: 'Vérifier mon aperçu', generateNew: 'Créer un nouvel aperçu',
      unavailable: 'La création d’aperçus de dalles est momentanément indisponible. Réessayez plus tard.',
      pendingStatus: 'Votre aperçu est peut-être encore en cours. Vérifiez-le avant d’en créer un autre.', available: 'Choisissez une finition, puis créez un aperçu du sol automatiquement avec l’IA.',
      busyHint: 'Gardez cette page ouverte pendant la préparation de votre aperçu.', pendingHint: 'Votre demande a été envoyée. Vérifiez le même aperçu sans en créer un nouveau.',
      oldResult: (previous, selected) => 'Aperçu affiché : ' + previous + '. Créez un nouvel aperçu pour voir la finition ' + selected + '.',
      resultHint: name => 'Aperçu IA / Dalles ' + name + '. La couleur, la texture et l’échelle peuvent différer du produit réel.',
      readyHint: 'Votre photo est prête. Choisissez votre finition, puis créez votre aperçu.', resultAlt: name => 'Aperçu IA du sol avec les dalles emboîtables Cavador ' + name,
      originalValue: 'Espace original', previewValue: 'Aperçu IA', percentage: value => value + ' % d’aperçu IA',
      unexpectedResponse: 'Le service a fourni une réponse inattendue. Réessayez plus tard.', serviceUnavailable: 'Le service d’aperçu est indisponible. Réessayez plus tard.',
      unsupportedResult: 'Le service a fourni un résultat incompatible.', finishedWithoutImage: 'L’aperçu est terminé, mais aucune image n’a été fournie. Contactez-nous pour obtenir de l’aide.',
      failedPreview: 'Impossible de créer cet aperçu. Vous pouvez en créer un nouveau.', unconfirmedStatus: 'Impossible de confirmer l’état de l’aperçu. Vérifiez-le à nouveau.',
      slowPreview: 'Votre aperçu prend plus de temps que prévu. Sélectionnez Vérifier mon aperçu pour consulter la même demande.', checkingPreview: 'Vérification de votre aperçu',
      unconfirmedRequest: 'Impossible de confirmer la demande. Elle ne sera pas relancée automatiquement.', invalidStatusAddress: 'Le service a fourni une adresse de suivi invalide.',
      stillProcessing: 'Votre aperçu est toujours en cours. Sélectionnez Vérifier mon aperçu pour consulter la même demande.',
      requestTimeout: 'Impossible de confirmer la demande. Elle ne sera pas relancée automatiquement. Patientez avant de créer un autre aperçu.',
      generationFailed: 'Impossible de créer l’aperçu. Il ne sera pas relancé automatiquement.'
    }
  };
  const uploadIcon = '<svg class="ct-upload-icon" viewBox="0 0 48 56" fill="none" aria-hidden="true"><path d="M8 8h23l9 9v31H8z" stroke="currentColor"/><path d="M31 8v10h9M24 38V23m-6 6 6-6 6 6" stroke="currentColor"/></svg>';
  const POLL_MS = 2500;
  const JOB_TIMEOUT_MS = 240000;

  class TileVisualizer {
    constructor(root) {
      this.root = root;
      this.locale = /^fr(?:[-_]|$)/i.test(root.dataset.locale || document.documentElement.lang || 'en') ? 'fr' : 'en';
      this.copy = copy[this.locale];
      this.image = null;
      this.selected = finishes[0];
      this.result = null;
      this.pendingJob = null;
      this.busy = false;
      this.aiAvailable = false;
      this.availability = 'checking';
      this.jobsEndpoint = root.dataset.jobsEndpoint || '/api/jobs';
      this.statusEndpoint = root.dataset.statusEndpoint || '/api/status';
      this.uid = 'ct-' + Math.random().toString(36).slice(2, 9);
      const id = name => this.uid + '-' + name;
      const c = this.copy;
      root.innerHTML = `
        <div class="ct-intro"><div><div class="ct-eyebrow">${c.eyebrow}</div><h1 class="ct-title">${c.title}</h1></div><p>${c.intro}</p></div>
        <div class="ct-workspace">
          <div class="ct-stage-col">
            <div class="ct-stage-top"><div class="ct-stepbar"><span data-step="1" class="is-active"><b>01</b> ${c.stepPhoto}</span><span data-step="2"><b>02</b> ${c.stepFinish}</span><span data-step="3"><b>03</b> ${c.stepPreview}</span></div><button type="button" class="ct-text-btn" data-action="replace" hidden>${c.changePhoto}</button></div>
            <div class="ct-error" role="alert" hidden></div>
            <div class="ct-stage">
              <div class="ct-drop">${uploadIcon}<h2>${c.dropTitle}</h2><p>${c.dropText}</p><button type="button" class="ct-btn" data-action="upload">${c.upload} <span aria-hidden="true">↗</span></button><button type="button" class="ct-text-btn" data-action="sample" ${root.dataset.sample ? '' : 'hidden'}>${c.sample}</button><p class="ct-filehint">${c.fileHint}</p></div>
              <div class="ct-image-wrap" hidden><img class="ct-room-image" alt="${c.originalAlt}"><img class="ct-after" alt="${c.previewAlt}" hidden><span class="ct-badge" hidden>${c.before}</span><span class="ct-badge ct-badge-after" hidden>${c.after}</span><div class="ct-compare-line" hidden></div><div class="ct-compare-knob" hidden aria-hidden="true">‹ ›</div></div>
              <div class="ct-loading" role="status" aria-live="polite" hidden><div class="ct-spinner" aria-hidden="true"></div><span>${c.creating}</span><small>${c.processing}</small></div>
            </div>
            <div class="ct-stage-footer"><p class="ct-hint" aria-live="polite">${c.startHint}</p><div class="ct-compare-controls" hidden><label for="${id('compare')}">${c.before}</label><input id="${id('compare')}" type="range" min="0" max="100" value="50" aria-label="${c.comparison}"><label for="${id('compare')}">${c.after}</label><div class="ct-result-actions"><button type="button" class="ct-download" data-action="download">${c.save}</button></div></div></div>
          </div>
          <aside class="ct-sidebar" aria-label="${c.selection}"><div class="ct-eyebrow">${c.collection}</div><h2>${c.chooseFinish}</h2><p class="ct-subtitle">${c.subtitle}</p><div class="ct-finish-grid">${finishes.map(f => `<button type="button" class="ct-finish" data-finish="${f.id}" aria-pressed="${f.id === this.selected.id}" aria-label="${c.choose(this.finishName(f))}"><span class="ct-swatch"><img src="${shop}/cdn/shop/files/${f.photo}&width=360" alt="${c.closeup(this.finishName(f))}" loading="lazy"><span class="ct-check" aria-hidden="true">✓</span></span>${this.finishName(f)}</button>`).join('')}</div>
            <div class="ct-product-detail"><div class="ct-selected-name">${this.finishName(this.selected)}</div><p class="ct-detail-meta">${c.detail}</p>
              <button type="button" class="ct-btn ct-render" data-action="generate" aria-describedby="${id('privacy')} ${id('service')}" disabled><span class="ct-generate-label">${c.generate}</span><span aria-hidden="true">→</span></button>
              <p class="ct-ai-note" id="${id('privacy')}">${c.privacy}</p><p class="ct-service-status" id="${id('service')}" role="status" aria-live="polite">${c.checking}</p>
              <a class="ct-product-link" href="${this.productURL(this.selected)}" target="_blank" rel="noopener">${c.explore(this.finishName(this.selected))}</a>
            </div>
          </aside>
        </div>
        <div class="ct-lower"><div class="ct-lower-item"><h3>${c.lowerPhotoTitle}</h3><p>${c.lowerPhoto}</p></div><div class="ct-lower-item"><h3>${c.lowerFinishTitle}</h3><p>${c.lowerFinish}</p></div><div class="ct-lower-item"><h3>${c.lowerNextTitle}</h3><p>${c.lowerNext}</p></div></div>
        <input type="file" data-file accept="image/jpeg,image/png,image/webp" hidden>
      `;
      this.$ = selector => root.querySelector(selector);
      this.$$ = selector => [...root.querySelectorAll(selector)];
      this.bind();
      this.update();
      this.checkAI();
      this.$$('.ct-swatch img').forEach(img => {
        const fallback = () => {
          const finish = finishes.find(f => f.id === img.closest('[data-finish]').dataset.finish);
          if (!finish) return;
          img.hidden = true;
          img.parentElement.style.background = finish.color;
        };
        img.addEventListener('error', fallback);
        if (img.complete && !img.naturalWidth) fallback();
      });
    }

    finishName(product) {
      const finish = finishes.find(f => f.id === product.id) || product;
      return this.locale === 'fr' ? finish.fr || finish.name : finish.name;
    }
    productURL(product) { return shop + (this.locale === 'fr' ? '/fr' : '') + '/products/' + productHandle + '?variant=' + product.variant; }
    controlsLocked() { return this.busy || !!this.pendingJob; }
    resultIsCurrent() { return !!this.result && this.result.surface === 'floor' && this.result.product.id === this.selected.id; }

    async checkAI() {
      try {
        const response = await fetch(this.statusEndpoint, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) });
        const data = await response.json();
        this.aiAvailable = response.ok && data.aiAvailable === true && data.automatic === true && data.asyncJobs === true && Array.isArray(data.surfaces) && data.surfaces.includes('floor');
      } catch { this.aiAvailable = false; }
      this.availability = this.aiAvailable ? 'available' : 'unavailable';
      this.update();
    }

    bind() {
      this.root.addEventListener('click', event => {
        const target = event.target.closest('button');
        if (!target || target.disabled || this.busy) return;
        const action = target.dataset.action;
        if (action === 'generate') { this.generate(); return; }
        if (this.controlsLocked()) return;
        if (action === 'upload' || action === 'replace') this.$('[data-file]').click();
        if (action === 'sample' && this.root.dataset.sample) this.loadPhoto(this.root.dataset.sample, true);
        if (action === 'download') this.download();
        if (target.dataset.finish) {
          const finish = finishes.find(f => f.id === target.dataset.finish);
          if (!finish) return;
          this.selected = finish;
          this.refreshSelection();
        }
      });
      this.$('[data-file]').addEventListener('change', event => {
        const file = event.target.files[0];
        if (!file || this.controlsLocked()) return;
        this.loadFile(file).finally(() => { event.target.value = ''; });
      });
      const stage = this.$('.ct-stage');
      stage.addEventListener('dragover', event => {
        event.preventDefault();
        if (!this.controlsLocked()) stage.classList.add('ct-dragover');
      });
      stage.addEventListener('dragleave', () => stage.classList.remove('ct-dragover'));
      stage.addEventListener('drop', event => {
        event.preventDefault();
        stage.classList.remove('ct-dragover');
        if (!this.controlsLocked() && event.dataTransfer.files[0]) this.loadFile(event.dataTransfer.files[0]);
      });
      this.$('.ct-compare-controls input').addEventListener('input', event => this.compare(Number(event.target.value)));
      const wrapper = this.$('.ct-image-wrap');
      const compareAt = event => {
        const rect = wrapper.getBoundingClientRect();
        const divider = Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100));
        this.compare(100 - divider);
      };
      wrapper.addEventListener('pointerdown', event => {
        if (!this.result || this.controlsLocked()) return;
        this.compareDragging = true;
        wrapper.setPointerCapture(event.pointerId);
        compareAt(event);
      });
      wrapper.addEventListener('pointermove', event => { if (this.compareDragging) compareAt(event); });
      wrapper.addEventListener('pointerup', () => { this.compareDragging = false; });
      wrapper.addEventListener('pointercancel', () => { this.compareDragging = false; });
    }

    refreshSelection() {
      this.$$('[data-finish]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.finish === this.selected.id)));
      this.$('.ct-selected-name').textContent = this.finishName(this.selected);
      const link = this.$('.ct-product-link');
      link.href = this.productURL(this.selected);
      link.textContent = this.copy.explore(this.finishName(this.selected));
      this.error('');
      this.update();
    }

    error(message) {
      this.$('.ct-error').textContent = message;
      this.$('.ct-error').hidden = !message;
    }

    async loadFile(file) {
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) { this.error(this.copy.invalidType); return; }
      if (file.size > 20 * 1024 * 1024) { this.error(this.copy.tooLarge); return; }
      const url = URL.createObjectURL(file);
      try { await this.loadPhoto(url, false); } finally { URL.revokeObjectURL(url); }
    }

    loadImage(url) {
      return new Promise((resolve, reject) => {
        if (typeof url !== 'string' || !url) { reject(new Error(this.copy.missingImage)); return; }
        const image = new Image();
        if (/^https?:/i.test(url)) image.crossOrigin = 'anonymous';
        const timeout = setTimeout(() => { image.onload = image.onerror = null; reject(new Error(this.copy.imageTimeout)); }, 30000);
        image.onload = () => { clearTimeout(timeout); resolve(image); };
        image.onerror = () => { clearTimeout(timeout); reject(new Error(this.copy.cannotOpen)); };
        image.src = url;
      });
    }

    async loadPhoto(url, sample) {
      if (this.controlsLocked()) return;
      this.error('');
      this.busy = true;
      this.$('.ct-loading span').textContent = this.copy.preparing;
      this.$('.ct-loading small').textContent = this.copy.opening;
      this.$('.ct-loading').hidden = false;
      this.update();
      try {
        const image = await this.loadImage(url);
        if (image.naturalWidth < 200 || image.naturalHeight < 200) throw new Error(this.copy.tooSmall);
        if (image.naturalWidth * image.naturalHeight > 60000000) throw new Error(this.copy.tooManyPixels);
        const resized = document.createElement('canvas');
        const ratio = Math.min(1, 1800 / Math.max(image.naturalWidth, image.naturalHeight));
        resized.width = Math.round(image.naturalWidth * ratio);
        resized.height = Math.round(image.naturalHeight * ratio);
        resized.getContext('2d').drawImage(image, 0, 0, resized.width, resized.height);
        const normalized = await this.loadImage(resized.toDataURL('image/png'));
        this.image = normalized;
        this.hideResult();
        this.$('.ct-room-image').src = normalized.src;
        this.$('.ct-room-image').alt = sample ? this.copy.sampleAlt : this.copy.uploadedAlt;
        this.$('.ct-drop').hidden = true;
        this.$('.ct-image-wrap').style.setProperty('--ct-photo-width', (640 * resized.width / resized.height) + 'px');
        this.$('.ct-image-wrap').hidden = false;
        this.$('[data-action=replace]').hidden = false;
      } catch (error) {
        this.error(error.message || this.copy.cannotOpen);
      } finally {
        this.busy = false;
        this.$('.ct-loading').hidden = true;
        this.update();
      }
    }

    update() {
      const c = this.copy;
      const locked = this.controlsLocked();
      this.root.setAttribute('aria-busy', String(this.busy));
      this.$$('button:not([data-action="generate"]),input').forEach(el => { el.disabled = locked; });
      const generate = this.$('[data-action=generate]');
      generate.disabled = !this.image || !this.aiAvailable || this.busy;
      this.$('.ct-generate-label').textContent = this.busy ? c.wait : this.pendingJob ? c.checkPreview : this.result ? c.generateNew : c.generate;
      this.$('.ct-compare-controls').hidden = !this.result;
      this.$('.ct-image-wrap').classList.toggle('has-result', !!this.result);
      this.$$('[data-step]').forEach(el => {
        const current = Number(el.dataset.step) === (this.result ? 3 : this.image ? 2 : 1);
        el.classList.toggle('is-active', current);
        if (current) el.setAttribute('aria-current', 'step'); else el.removeAttribute('aria-current');
      });
      this.$('.ct-service-status').textContent = this.availability === 'checking' ? c.checking : !this.aiAvailable ? c.unavailable : this.pendingJob && !this.busy ? c.pendingStatus : c.available;
      this.$('.ct-hint').textContent = this.busy ? c.busyHint : this.pendingJob ? c.pendingHint : this.result && !this.resultIsCurrent() ? c.oldResult(this.finishName(this.result.product), this.finishName(this.selected)) : this.result ? c.resultHint(this.finishName(this.result.product)) : this.image ? c.readyHint : c.startHint;
    }

    hideResult() {
      this.result = null;
      this.$('.ct-after').hidden = true;
      this.$$('.ct-badge,.ct-compare-line,.ct-compare-knob').forEach(el => { el.hidden = true; });
    }

    showResult(url, request) {
      this.result = { url, product: request.product, surface: request.surface };
      this.$('.ct-after').src = url;
      this.$('.ct-after').alt = this.copy.resultAlt(this.finishName(request.product));
      this.$('.ct-after').hidden = false;
      this.$$('.ct-badge,.ct-compare-line,.ct-compare-knob').forEach(el => { el.hidden = false; });
      this.compare(50);
    }

    compare(value) {
      const after = Number.isFinite(Number(value)) ? Math.max(0, Math.min(100, Number(value))) : 50;
      const divider = 100 - after;
      const slider = this.$('.ct-compare-controls input');
      slider.value = after;
      slider.setAttribute('aria-valuetext', after === 0 ? this.copy.originalValue : after === 100 ? this.copy.previewValue : this.copy.percentage(Math.round(after)));
      this.$('.ct-after').style.clipPath = `inset(0 0 0 ${divider}%)`;
      this.$('.ct-compare-line').style.left = divider + '%';
      this.$('.ct-compare-knob').style.left = divider + '%';
    }

    download() {
      if (!this.result) return;
      const link = document.createElement('a');
      link.href = this.result.url;
      link.download = `cavador-${this.result.product.id}-floor-preview.png`;
      link.click();
    }

    serviceError(data, fallback) {
      // Server messages are reviewed English copy; use the localized fallback in French.
      if (this.locale === 'fr') return fallback;
      return typeof data.error === 'string' ? data.error : data.error?.message || fallback;
    }

    async readResponse(response) {
      let data;
      try { data = await response.json(); } catch { throw new Error(this.copy.unexpectedResponse); }
      if (!response.ok) {
        const error = new Error(this.serviceError(data, this.copy.serviceUnavailable));
        error.status = response.status;
        throw error;
      }
      return data;
    }

    async waitForJob(job, deadline) {
      while (Date.now() < deadline) {
        const response = await fetch(job.pollUrl, { credentials: 'same-origin', signal: AbortSignal.timeout(Math.max(1, Math.min(30000, deadline - Date.now()))) });
        const data = await this.readResponse(response);
        if (data.status === 'completed') {
          if (data.mode !== 'automatic' || data.requiresCompositing !== false || data.surface !== 'floor') { this.pendingJob = null; throw new Error(this.copy.unsupportedResult); }
          if (typeof data.image !== 'string' || !data.image) { this.pendingJob = null; throw new Error(this.copy.finishedWithoutImage); }
          return data;
        }
        if (data.status === 'failed') {
          this.pendingJob = null;
          throw new Error(this.serviceError(data, this.copy.failedPreview));
        }
        if (!['running', 'queued', 'pending'].includes(data.status)) throw new Error(this.copy.unconfirmedStatus);
        const remaining = deadline - Date.now();
        if (remaining <= 0) break;
        await new Promise(resolve => setTimeout(resolve, Math.min(POLL_MS, remaining)));
      }
      const error = new Error(this.copy.slowPreview);
      error.name = 'PreviewTimeoutError';
      throw error;
    }

    async generate() {
      if (!this.image || !this.aiAvailable || this.busy) return;
      this.error('');
      this.busy = true;
      this.$('.ct-loading span').textContent = this.pendingJob ? this.copy.checkingPreview : this.copy.creating;
      this.$('.ct-loading small').textContent = this.copy.processing;
      this.$('.ct-loading').hidden = false;
      this.update();
      try {
        const deadline = Date.now() + JOB_TIMEOUT_MS;
        if (!this.pendingJob) {
          const request = { image: this.image.src, product: { id: this.selected.id, name: this.selected.name }, surface: 'floor' };
          const response = await fetch(this.jobsEndpoint, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(request),
            credentials: 'same-origin', signal: AbortSignal.timeout(30000)
          });
          const data = await this.readResponse(response);
          if (typeof data.jobId !== 'string' || !/^[A-Za-z0-9_-]{32}$/.test(data.jobId)) throw new Error(this.copy.unconfirmedRequest);
          const pollPath = this.jobsEndpoint.replace(/\/$/, '') + '/' + encodeURIComponent(data.jobId);
          const pollURL = new URL(pollPath, location.href);
          if (pollURL.origin !== location.origin) throw new Error(this.copy.invalidStatusAddress);
          this.pendingJob = { jobId: data.jobId, pollUrl: pollURL.href, product: request.product, surface: request.surface, width: this.image.naturalWidth, height: this.image.naturalHeight };
        }
        const job = this.pendingJob;
        const data = await this.waitForJob(job, deadline);
        const generated = await this.loadImage(data.image);
        const output = document.createElement('canvas');
        output.width = job.width;
        output.height = job.height;
        output.getContext('2d').drawImage(generated, 0, 0, output.width, output.height);
        const url = output.toDataURL('image/png');
        this.pendingJob = null;
        this.showResult(url, job);
      } catch (error) {
        if (error.status === 404 || error.status === 410) this.pendingJob = null;
        const message = error.name === 'TimeoutError' || error.name === 'PreviewTimeoutError'
          ? this.pendingJob ? this.copy.stillProcessing : this.copy.requestTimeout
          : error.message || this.copy.generationFailed;
        this.error(message);
      } finally {
        this.busy = false;
        this.$('.ct-loading').hidden = true;
        this.update();
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-ct-root]').forEach(root => {
      if (!root.dataset.ctInitialized) {
        root.dataset.ctInitialized = 'true';
        new TileVisualizer(root);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
